import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { IClient } from '../types/Client'
import { getManagersNames } from '../lib/getManagersNames'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { getLabelNames } from '../lib/getLabelNames'

export const fetchClient = createAsyncThunk<
	{ client: IClient; managerNames: string[], labelNames: string[] },
	string,
	ThunkConfig<string>
>('fetchClient', async (clientId, thunkApi) => {
	const {
		extra: { api },
		rejectWithValue
	} = thunkApi

	try {
		const res = await api.get<IClient>(`/clients/${clientId}`)
		const client = res.data
		const managerNames = getManagersNames(client)
		const labelNames = getLabelNames(client)

		return { client, managerNames, labelNames }
	} catch (e) {
		console.log(e)
		appHandleError(e, 'fetchClient', 'Failed to fetch client data')
		return rejectWithValue('Error occurred on fetching client')
	}
})
